export const DEFAULT_NOTIFICATION_PREFERENCES = {
  logs: true,
  poi: true,
  tideCalculator: true,
};

export const NOTIFICATION_PREFERENCE_ITEMS = [
  {
    key: 'logs',
    label: 'Logi',
    description: 'Powiadomienia po automatycznym zapisie logu (np. z aplikacji mobilnej).',
  },
  {
    key: 'poi',
    label: 'POI',
    description: 'Powiadomienia po zbliżeniu do punktu zainteresowania.',
  },
  {
    key: 'tideCalculator',
    label: 'Kalkulator pływów',
    description: 'Powiadomienia o zbliżających się wysokich i niskich wodach.',
  },
];

export function normalizeNotificationPreferences(value) {
  const merged = { ...DEFAULT_NOTIFICATION_PREFERENCES };
  if (!value || typeof value !== 'object') return merged;

  merged.logs = typeof value.logs === 'boolean' ? value.logs : merged.logs;
  merged.poi = typeof value.poi === 'boolean' ? value.poi : merged.poi;

  if (typeof value.tideCalculator === 'boolean') {
    merged.tideCalculator = value.tideCalculator;
  } else if (typeof value.tide_calculator === 'boolean') {
    merged.tideCalculator = value.tide_calculator;
  }

  return merged;
}

/** Format zgodny z aplikacją mobilną (snake_case). */
export function serializeNotificationPreferencesForApi(preferences) {
  const normalized = normalizeNotificationPreferences(preferences);
  return {
    logs: normalized.logs,
    poi: normalized.poi,
    tide_calculator: normalized.tideCalculator,
  };
}
